import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle
} from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { format, parse } from 'date-fns';
import moment from 'moment';
import { NgxMatTimepickerComponent, NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { WorkshopJob } from 'src/app/models/workshop-job';
import { AddressSearchFieldComponent } from '../../../../../shared/general/address-search-field/address-search-field.component';
import { ViewWorkshopJobStoreService } from '../../../view-workshop-job-store.service';

@Component({
  selector: 'app-edit-site-visit-dialog',
  templateUrl: './edit-site-visit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatIcon,
    CdkTextareaAutosize,
    AddressSearchFieldComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatError,
    MatSuffix,
    NgxMatTimepickerModule
  ]
})
export class EditSiteVisitDialogComponent {
  form = this.fb.group({
    address: this.fb.control<null | { address: string; place_id: string }>(
      null,
      Validators.required
    ),
    typedAddress: this.fb.control<string | null>(null, {
      validators: Validators.required
    }),
    time: this.fb.control<string | null>(null, Validators.required),
    date: this.fb.control<moment.Moment | null>(null, Validators.required)
  });

  typeAddress = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditSiteVisitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkshopJob<any>,
    private store: ViewWorkshopJobStoreService
  ) {
    const { site_visit_address, site_place_id, site_visit_date } = data;
    this.form.patchValue({
      address: site_place_id
        ? { address: site_visit_address, place_id: site_place_id }
        : null,
      typedAddress: site_place_id ? null : site_visit_address,
      time: site_visit_date ? format(new Date(site_visit_date), 'HH:mm') : null,
      date: moment(site_visit_date)
    });
    if (site_visit_date && !site_place_id) {
      this.toggleTypeAddress();
    } else {
      this.updateAddressDisabledStatus();
    }
  }

  toggleTypeAddress() {
    this.typeAddress = !this.typeAddress;
    this.updateAddressDisabledStatus();
  }

  private updateAddressDisabledStatus() {
    const typeAddress = this.form.get('typedAddress');
    const addressSearch = this.form.get('address');
    if (this.typeAddress) {
      addressSearch.reset();
      addressSearch.disable();
      typeAddress.enable();
    } else {
      typeAddress.reset();
      typeAddress.disable();
      addressSearch.enable();
    }
    this.form.updateValueAndValidity();
  }

  save() {
    const {
      address: { address, place_id },
      time,
      date
    } = this.form.value as any;
    this.store.updateJob({
      ...this.data,
      site_visit_address: address,
      site_place_id: place_id,
      site_visit_date: parse(time, 'HH:mm', date.toDate()).toISOString()
    });
    this.dialogRef.close();
  }

  updateTime(event: any, field: string) {
    this.form.get(field).patchValue(event);
  }

  updateTimeEnteredManually(field: string, picker: NgxMatTimepickerComponent) {
    const control = this.form.get(field);
    if (!control.value) {
      return;
    }
    // 24 hr patterns to try and parse
    const parsePatterns = ['HH:mm', 'HH.mm', 'H:mm', 'HHmm', 'Hmm', 'HH', 'H'];
    const invalidValue = control.value;
    for (const pattern of parsePatterns) {
      const parsed = parse(invalidValue, pattern, new Date());
      if (parsed.toString() !== 'Invalid Date') {
        control.patchValue(format(parsed, 'HH:mm'));
        return picker.updateTime(control.value);
      }
    }
    control.setErrors({ invalidTime: true });
  }
}
